import { IBookmark } from "@/models/IBookmark";
import { LocalStorageHelper } from "@/utils/local-storage-helper"
class BookmarksApiService {
	getAndStoreBookmarks = async (memberId: string) => {
		const response = await fetch(
			`/Umbraco/api/Bookmarks/GetBookmarksByMemberId?memberId=${memberId}`,
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
			},
		)
		const bookmarks = await response.json()
		if (bookmarks?.message) {
			LocalStorageHelper.setItem(`bookmarks-${memberId}`, []);
            return [];
		} else {
			LocalStorageHelper.setItem(`bookmarks-${memberId}`, bookmarks as IBookmark[]);
            return bookmarks as IBookmark[];
		}		
	}

	addBookmark = async (memberId: string, pageId: number) => {
		const response = await fetch(`/Umbraco/api/Bookmarks/SaveBookmark`, {
			method: 'POST',
			body: JSON.stringify({
				MemberId: memberId,
				PageId: pageId,
			}),
			headers: {
				'Content-Type': 'application/json',
			},
		})
		const newBookmark = await response.json()
		await this.getAndStoreBookmarks(memberId)
		return newBookmark
	}

	deleteBookmark = async (memberId: string, pageId: number) => {
		const response = await fetch(
			`/Umbraco/api/Bookmarks/DeleteBookmark?memberId=${memberId}&pageId=${pageId}`,
			{
				method: 'DELETE',
				headers: {
					'Content-Type': 'application/json',
				},
			},
		)
		const deletedBookmark = await response.json()
		await this.getAndStoreBookmarks(memberId)
		return deletedBookmark
	}
}

export const bookmarksApiService = new BookmarksApiService()
